import ManualEntryScreen from './ManualEntryScreen';

export default ManualEntryScreen;
